/* sc-cart-drawer-preview.js
 * Behavior-only enhancer for server-rendered cart drawer Preview actions.
 * Liquid owns provider resolution, image selection and initial markup. This
 * singleton only refreshes the approved metadata attributes, removes stale or
 * duplicate compact actions after section replacement, and tracks one observer.
 */
(function () {
  'use strict';

  var existing = window.__scCartDrawerPreviewController;
  if (existing && typeof existing.start === 'function') {
    existing.start();
    existing.refresh();
    return;
  }

  function installCountdownDisconnectCleanup() {
    var CountdownTimer = window.customElements && window.customElements.get('countdown-timer');
    if (!CountdownTimer) return;
    var prototype = CountdownTimer.prototype;
    if (prototype.__scDisconnectCleanupInstalled) return;

    var originalDisconnectedCallback = prototype.disconnectedCallback;
    prototype.disconnectedCallback = function () {
      if (this.playInterval) {
        clearInterval(this.playInterval);
        this.playInterval = null;
      }
      this.isPlaying = false;
      if (typeof originalDisconnectedCallback === 'function') {
        originalDisconnectedCallback.call(this);
      }
    };
    prototype.__scDisconnectCleanupInstalled = true;
  }

  if (window.customElements) {
    if (window.customElements.get('countdown-timer')) {
      installCountdownDisconnectCleanup();
    } else {
      window.customElements.whenDefined('countdown-timer').then(installCountdownDisconnectCleanup);
    }
  }

  var ROW_SELECTOR = 'cart-drawer .cart-drawer-item[data-cart-item-key]';
  var METADATA_ATTRIBUTES = [
    'data-image',
    'data-hero-image',
    'data-hero-fallback',
    'data-photo-fallback',
    'data-price',
    'data-compare-price',
    'data-product-type',
    'data-title'
  ];
  var observer = null;
  var started = false;
  var rowCount = 0;

  function toArray(values) {
    return Array.prototype.slice.call(values || []);
  }

  function removeNode(node) {
    if (!node) return;
    if (typeof node.remove === 'function') {
      node.remove();
    } else if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
  }

  function copyMetadata(source, target) {
    for (var i = 0; i < METADATA_ATTRIBUTES.length; i++) {
      var name = METADATA_ATTRIBUTES[i];
      var value = source.getAttribute(name);
      if (value === null) {
        target.removeAttribute(name);
      } else {
        target.setAttribute(name, value);
      }
    }
  }

  function refreshRow(row) {
    var media = row.querySelector('.cart-item__media.sc-preview-show[data-image]');
    var buttons = toArray(row.querySelectorAll('.sc-cart-preview-btn--compact'));
    var personalized = !!(
      media &&
      media.getAttribute('data-sc-personalized-preview') === '1'
    );
    var canonicalButton = null;

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      if (personalized && !canonicalButton && media.contains(button)) {
        canonicalButton = button;
      } else {
        removeNode(button);
      }
    }

    if (canonicalButton) copyMetadata(media, canonicalButton);
  }

  function refresh() {
    var rows = toArray(document.querySelectorAll(ROW_SELECTOR));
    rowCount = rows.length;
    for (var i = 0; i < rows.length; i++) refreshRow(rows[i]);
  }

  function elementTouchesDrawer(node) {
    if (!node || node.nodeType !== 1) return false;
    if (typeof node.matches === 'function' && node.matches('cart-drawer, .cart-drawer-item, .drawer__inner, cart-drawer-items, #CartDrawer-CartItems')) {
      return true;
    }
    if (typeof node.closest === 'function' && node.closest('cart-drawer')) return true;
    return !!(
      typeof node.querySelector === 'function' &&
      node.querySelector('cart-drawer, .cart-drawer-item')
    );
  }

  function mutationTouchesDrawer(record) {
    if (!record) return false;
    if (elementTouchesDrawer(record.target)) return true;
    var changed = toArray(record.addedNodes).concat(toArray(record.removedNodes));
    for (var i = 0; i < changed.length; i++) {
      if (elementTouchesDrawer(changed[i])) return true;
    }
    return false;
  }

  function handleMutations(records) {
    for (var i = 0; i < (records || []).length; i++) {
      if (mutationTouchesDrawer(records[i])) {
        refresh();
        return;
      }
    }
  }

  function handleSectionLifecycle() {
    refresh();
  }

  function start() {
    if (started) {
      refresh();
      return;
    }
    if (!document.documentElement) return;

    started = true;
    document.addEventListener('shopify:section:load', handleSectionLifecycle);
    document.addEventListener('shopify:section:unload', handleSectionLifecycle);
    observer = new MutationObserver(handleMutations);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    refresh();
  }

  function stop() {
    if (!started) return;
    started = false;
    document.removeEventListener('shopify:section:load', handleSectionLifecycle);
    document.removeEventListener('shopify:section:unload', handleSectionLifecycle);
    if (observer) observer.disconnect();
    observer = null;
    rowCount = 0;
  }

  var controller = {
    start: start,
    stop: stop,
    refresh: refresh,
    getState: function () {
      return {
        started: started,
        observerActive: !!observer,
        rowCount: rowCount
      };
    }
  };

  window.__scCartDrawerPreviewInstalled = true;
  window.__scCartDrawerPreviewController = controller;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      document.removeEventListener('DOMContentLoaded', onReady);
      controller.start();
    });
  } else {
    controller.start();
  }
})();
